import React from 'react';

import {
  DropdownMenuItemRouter,
  PageHeaderDropdownMenuItem,
} from './PageHeaderDropdownMenu';

type Props = {
  to: string;
  isStaff?: boolean;
};

export function PageHeaderAccountDropdownConditionalMenuItem({
  to,
  isStaff,
  ...props
}: Props) {
  const Component = isStaff
    ? PageHeaderDropdownMenuItem
    : DropdownMenuItemRouter;
  const linkProps = isStaff
    ? {
        href: to,
      }
    : {
        to,
      };
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/jsx-props-no-spreading
  return <Component {...props} {...linkProps} />;
}
